<template lang="html">

  <section class="pack_configurator">
    <!--import-export-->
    <b-card
      header="Import - Export packs"
      header-bg-variant="primary"
      header-text-variant="light"
      id="import_export"
    >
      <b-card-text>
        <b-row>
          <b-col class="col-lg-6">
            Filter by model (export commercial pack):
            <input type="radio" v-model="modelFilter" name="packsForm:commPackExportModelFilter" value="ALL" class="ml-2">All
            <input type="radio" v-model="modelFilter" name="packsForm:commPackExportModelFilter" value="FAM" class="ml-2">This family
            <input type="radio" v-model="modelFilter" name="packsForm:commPackExportModelFilter" value="MOD" class="ml-2">This model
          </b-col>
          <b-col class="col-lg-2">This ModelYear only:<input v-model="currentModelYearOnly" type="checkbox" class="ml-2"/></b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="col-lg-12">
            <span class="float-right">
              <b-button variant="primary mr-1" @click="exportPack()"><i class="mdi mdi-file-export"></i>Export commercial packs</b-button>
              <b-button variant="primary mr-1" @click="initializeUpload()"><i class="mdi mdi-file-import"></i>Import all commercial packs</b-button>
              <b-button variant="primary mr-1" @click="exportImplicitPack()"><i class="mdi mdi-file-export"></i>Export all implicit packs</b-button>
              <b-button variant="primary mr-1" @click="initializeUploadImplicit()"><i class="mdi mdi-file-import"></i>Import all implicit packs</b-button>
            </span>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <!--commercial packs-->
    <b-card
      header="Commercial Packs"
      header-bg-variant="primary"
      header-text-variant="light"
      id="commercial_packs"
      class="mt-4"
    >
      <b-card-text>
        <b-row>
          <b-col class="col-lg-1 pt-2">Market:</b-col>          

          <b-select class="col-lg-5" v-model="selectedCountry" id="selectedCountry">
                <option :value="country" v-if="getCurUser" v-for="(country,index) in getCurUser.countries">{{country.description}}</option>         
          </b-select>
          <b-col class="col-lg-1 pt-2">Model:</b-col>

          <b-select class="col-lg-5" v-model="selectedModel" id="selectedModel">
            <template v-if="selectedCountry != null && selectedCountry.modelGroupItemList" v-for="models in ((selectedCountry && selectedCountry.modelGroupItemList) ? selectedCountry.modelGroupItemList : [])">
              <optgroup :label="models.label">
                  <option v-for="(model,index) in models.items" :key="index" :value="model">{{model.label}}</option>
              </optgroup>
            </template>
          </b-select>
        </b-row>
        <b-row class="mt-3">
          <b-col class="col-lg">
            <span class="float-right">
              <b-button variant="primary mr-1" @click="reloadBaseInfo()"><i class="mdi mdi-refresh"></i>Refresh</b-button>
            </span>
          </b-col>
        </b-row>
        <b-table
          id="packsTable" 
          striped 
          border
          hover 
          responsive
          sticky-header="500px"
          small
          :items="packList" 
          :fields="visibleFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="_id"
          no-local-sorting
          no-provider-paging
          sort-icon-left
          class="mt-4"
        >
          <!-- Custom row above header -->
          <template v-slot:thead-top="data" lang="html">
            <b-tr>
              <b-th variant="secondary" :colspan="visibleFields.length">List of Packs for model: {{selectedModel ? selectedModel.label.split(" ")[0] : ''}} / Market: {{selectedCountry ? selectedCountry.description : ''}}</b-th>
            </b-tr>
          </template>
          <!-- A custom formatted column -->
          <template v-slot:cell(parentCode)="data" lang="html">
            <span v-if="!data.item.isChild">{{data.item.ocparObj.parele}} - {{data.item.ocparObj.parde2}}</span>
          </template>
          <template v-slot:cell(childCode)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.ocparObj.parele}} - {{data.item.ocparObj.parde2}}</span>
          </template>
          <template v-slot:cell(inclExcl)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.priceIncluded}}</span>
          </template>
          <template v-slot:cell(optManovra)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.optManovra}}</span>
          </template>
          <template v-slot:cell(set)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.alternateSet}}</span>
          </template>
          <template v-slot:cell(default)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.defaultSet}}</span>
          </template>
          <template v-slot:cell(implicitPacksContent)="data" lang="html">
            <b-button v-b-modal.implicitPacksContentModal @click="{{curItem=data.item}}" v-if="data.item.ocparObj" variant="secondary"><i class="mdi mdi-magnify"></i></b-button>
          </template>
          <template v-slot:cell(plus)="data" lang="html">
            <b-button v-if="data.item.ocparObj && !data.item.isChild" variant="secondary" @click="openCloseRow(data.item.ocparObj)">
              <i :class="'mdi mdi-'+(showChildren.includes(data.item.ocparObj)?'minus':'plus')"></i>
            </b-button>
          </template>
        </b-table>
        <!-- Inizio Modal import -->
        <b-modal id="modal-import" title="Upload File"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>

            <div class='modal-body'>
              <!-- Form -->
              <form method='post' action='' enctype='multipart/form-data'>
                <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input' name='filename' @change="changeFileName()">
                <label class='custom-file-label' for='file-input'>{{fileName}}</label>
                </div>
                <br>
              </form>
              <!-- Preview-->
              <!-- <div id='preview'></div> -->
              <h2 v-if="imported">Import executed</h2>
              <template v-if='uploadImportCommlistResultView'>
                <span style="color:red;">ATTENTION: problems occurred during loading the following items:</span><br/><br/>
                <span style="color:red;" :key = 'errorMsg' v-for="errorMsg in uploadImportCommlistResultView.uploadErrorMsgList">
                  {{errorMsg}}<br/>
                </span>
              </template>
              <div v-if="!imported">
                <b-table
                  id="uploadEquipmentPreview"
                  striped
                  border
                  hover
                  responsive
                  sticky-header="500px"
                  small
                  :items="uploadImportCommlistResultView ? uploadImportCommlistResultView.uploadedList : []"
                  :fields="uploadCommPreviewFields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  primary-key="_id"
                  no-local-sorting
                  no-provider-paging
                  sort-icon-left
                  class="mt-3"
                >
                <!-- Custom row above header -->
                  <template v-slot:thead-top="data" lang="html">
                    <b-tr>
                      <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Import</b-th>
                    </b-tr>
                  </template>
                  <!--  rows  -->
                  <template v-slot:cell(isChecked)="data" lang="html">
                    <input v-if="data.item.status == 0 && data.item.isHeader" type="checkbox" v-model="data.item.isChecked" @change="editUploadedItem(data.item)" checked="data.item.isChecked"/>
                    <i v-if="data.item.status == 0 && !data.item.isHeader" class="mdi mdi-check" v-model="data.item.isChecked" style="display: block; color:green;"><!-- --></i>                
                    <i v-if="data.item.status != 0 && !data.item.isHeader" class="mdi mdi-window-close" v-model="data.item.isChecked = false" style="display: block; color:red;"><!-- --></i>                
                  </template>
                  <template v-slot:cell(model)="data" lang="html">
                    <b><span>{{data.item.vetList[0]}}</span></b>           
                  </template>
                  <template v-slot:cell(parentCode)="data" lang="html">
                    <b><span>{{data.item.parentCode}}</span></b>           
                  </template>
                  <template v-slot:cell(ver)="data" lang="html">
                    <b><span>{{data.item.ver}}</span></b>           
                  </template>
                  <template v-slot:cell(country)="data" lang="html">
                    <b><span>{{data.item.country}}</span></b>           
                  </template>
                  <template v-slot:cell(compulsory)="data" lang="html">
                    <span v-if="data.item.isHeader"><b>{{data.item.compulsory}}</b></span>
                    <span v-if="!data.item.isHeader">{{data.item.compulsory}}</span>  
                  </template>
                  <template v-slot:cell(childCode)="data" lang="html">
                    <span v-if="data.item.isHeader"><b>{{data.item.childCode}}</b></span>
                    <span v-if="!data.item.isHeader">{{data.item.childCode}}</span>  
                  </template>
                  <template v-slot:cell(status)="data"  lang="html">
                    <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
                  </template>
                </b-table>
              </div>
              <!-- RESULT TABLES -->
              <div v-if="imported">
                <b-table
                id="importedCommPack"
                striped
                border
                hover
                responsive
                sticky-header="500px"
                small
                :items="uploadImportCommlistResultView ? uploadImportCommlistResultView.importedList : []"
                :fields="uploadCommPreviewFields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="_id"
                no-local-sorting
                no-provider-paging
                sort-icon-left
                class="mt-3"
              >
              <!-- Custom row above header -->
                <template v-slot:thead-top="data" lang="html">
                  <b-tr>
                    <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Imported</b-th>
                  </b-tr>
                </template>
                <!--  rows  -->
                <template v-slot:cell(isChecked)="data" lang="html">
                  <span><!-- --></span>                
                </template>
                <template v-slot:cell(model)="data" lang="html">
                  <b><span>{{data.item.vetList[0]}}</span></b>           
                </template>
                <template v-slot:cell(parentCode)="data" lang="html">
                  <b><span>{{data.item.parentCode}}</span></b>           
                </template>
                <template v-slot:cell(ver)="data" lang="html">
                  <b><span>{{data.item.ver}}</span></b>           
                </template>
                <template v-slot:cell(country)="data" lang="html">
                  <b><span>{{data.item.country}}</span></b>           
                </template>
                <template v-slot:cell(compulsory)="data" lang="html">
                  <span v-if="data.item.isHeader"><b>{{data.item.compulsory}}</b></span>
                  <span v-if="!data.item.isHeader">{{data.item.compulsory}}</span>  
                </template>
                <template v-slot:cell(childCode)="data" lang="html">
                  <span v-if="data.item.isHeader"><b>{{data.item.childCode}}</b></span>
                  <span v-if="!data.item.isHeader">{{data.item.childCode}}</span>  
                </template>
                <template v-slot:cell(status)="data"  lang="html">
                  <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
                </template>
              </b-table>
              </div>
              <div v-if="imported">
                <b-table
                id="notImportedCommPack"
                striped
                border
                hover
                responsive
                sticky-header="500px"
                small
                :items="uploadImportCommlistResultView ? uploadImportCommlistResultView.notImportedList : []"
                :fields="uploadCommPreviewFields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="_id"
                no-local-sorting
                no-provider-paging
                sort-icon-left
                class="mt-3"
              >
              <!-- Custom row above header -->
                <template v-slot:thead-top="data" lang="html">
                  <b-tr>
                    <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Not Imported</b-th>
                  </b-tr>
                </template>
                <!--  rows  -->
                <template v-slot:cell(isChecked)="data" lang="html">
                  <span><!-- --></span>
                </template>
                <template v-slot:cell(model)="data" lang="html">
                  <b><span>{{data.item.vetList[0]}}</span></b>           
                </template>
                <template v-slot:cell(parentCode)="data" lang="html">
                  <b><span>{{data.item.parentCode}}</span></b>           
                </template>
                <template v-slot:cell(ver)="data" lang="html">
                  <b><span>{{data.item.ver}}</span></b>           
                </template>
                <template v-slot:cell(country)="data" lang="html">
                  <b><span>{{data.item.country}}</span></b>           
                </template>
                <template v-slot:cell(compulsory)="data" lang="html">
                  <span v-if="data.item.isHeader"><b>{{data.item.compulsory}}</b></span>
                  <span v-if="!data.item.isHeader">{{data.item.compulsory}}</span>  
                </template>
                <template v-slot:cell(childCode)="data" lang="html">
                  <span v-if="data.item.isHeader"><b>{{data.item.childCode}}</b></span>
                  <span v-if="!data.item.isHeader">{{data.item.childCode}}</span>  
                </template>
                <template v-slot:cell(status)="data"  lang="html">
                  <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
                </template>
              </b-table>
              </div>
            </div>
          <template v-slot:modal-footer="{ cancel, ok }" lang="html">
            <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
              <b-button variant="primary" @click="uploadCommFile()">
                Upload
              </b-button>
              <b-button v-if="uploadImportCommlistResultView && !imported" variant="primary" @click="importCommList()">
                Import
              </b-button>
            </fragment>
          </template>
        </b-modal>
        <!-- Fine Modal import -->
        <!-- Inizio Modal import Implicit-->
        <b-modal id="modal-import-implicit" title="Upload File"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>

            <div class='modal-body'>
              <!-- Form -->
              <form method='post' action='' enctype='multipart/form-data'>
                <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input-implicit' name='filename' @change="changeFileNameImplicit()">
                <label class='custom-file-label' for='file-input-implicit'>{{fileName}}</label>
                </div>
                <br>
              </form>
              <!-- Preview-->
              <!-- <div id='preview'></div> -->
              <h2 v-if="importedImplicit">Import executed</h2>
              <template v-if='uploadImportImplicitlistResultView'>
                <span style="color:red;">ATTENTION: problems occurred during loading the following items:</span><br/><br/>
                <span style="color:red;" :key = 'errorMsg' v-for="errorMsg in uploadImportImplicitlistResultView.uploadErrorMsgList">
                  {{errorMsg}}<br/>
                </span>
              </template>
              <div v-if="!importedImplicit">
                <b-table
                  id="uploadImplicitPreview"
                  striped
                  border
                  hover
                  responsive
                  sticky-header="500px"
                  small
                  :items="uploadImportImplicitlistResultView ? uploadImportImplicitlistResultView.uploadedList : []"
                  :fields="uploadImplicitPreviewFields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  primary-key="_id"
                  no-local-sorting
                  no-provider-paging
                  sort-icon-left
                  class="mt-3"
                >
                <!-- Custom row above header -->
                  <template v-slot:thead-top="data" lang="html">
                    <b-tr>
                      <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Import</b-th>
                    </b-tr>
                  </template>
                  <!--  rows  -->
                  <template v-slot:cell(isChecked)="data" lang="html">
                    <input v-if="data.item.status == 0 && data.item.isHeader" type="checkbox" v-model="data.item.isChecked" @change="editUploadedItem(data.item)" checked="data.item.isChecked"/>
                    <i v-if="data.item.status == 0 && !data.item.isHeader" class="mdi mdi-check" v-model="data.item.isChecked = false" style="display: block; color:green;"><!-- --></i>                
                    <i v-if="data.item.status != 0" class="mdi mdi-window-close" v-model="data.item.isChecked = false" style="display: block; color:red;"><!-- --></i>                
                  </template>
                  <template v-slot:cell(status)="data"  lang="html">
                    <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
                  </template>
                  <template v-slot:cell(code)="data" lang="html">
                    <span v-if="data.item.isHeader"><b>{{data.item.code}}</b></span>
                    <span v-if="!data.item.isHeader">{{data.item.code}}</span>  
                  </template>
                  <template v-slot:cell(name)="data" lang="html">
                    <span v-if="data.item.isHeader && data.item.status == 0"><b>{{data.item.name}}</b></span>
                    <span v-if="data.item.isHeader && data.item.status != 0"><b>{{data.item.name}}</b> <span style="color:red;">THIS PACK WILL NOT BE IMPORTED</span></span> 
                    <span v-if="!data.item.isHeader">{{data.item.name}}</span>  
                  </template>
                </b-table>
              </div>
              <!-- RESULT TABLES IMPLICIT-->
              <div v-if="importedImplicit">
                <b-table
                  id="uploadImplicitImported"
                  striped
                  border
                  hover
                  responsive
                  sticky-header="500px"
                  small
                  :items="uploadImportImplicitlistResultView ? uploadImportImplicitlistResultView.importedList : []"
                  :fields="uploadImplicitPreviewFields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  primary-key="_id"
                  no-local-sorting
                  no-provider-paging
                  sort-icon-left
                  class="mt-3"
                >
                <!-- Custom row above header -->
                  <template v-slot:thead-top="data" lang="html">
                    <b-tr>
                      <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Imported</b-th>
                    </b-tr>
                  </template>
                  <!--  rows  -->
                  <template v-slot:cell(isChecked)="data" lang="html">
                    <i v-if="data.item.status == 0" class="mdi mdi-check" v-model="data.item.isChecked" style="display: block; color:green;"><!-- --></i>                
                  </template>
                  <template v-slot:cell(status)="data"  lang="html">
                    <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
                  </template>
                  <template v-slot:cell(code)="data" lang="html">
                    <span v-if="data.item.isHeader"><b>{{data.item.code}}</b></span>
                    <span v-if="!data.item.isHeader">{{data.item.code}}</span>  
                  </template>
                  <template v-slot:cell(name)="data" lang="html">
                    <span v-if="data.item.isHeader"><b>{{data.item.name}}</b></span>
                    <span v-if="!data.item.isHeader">{{data.item.name}}</span>  
                  </template>
                </b-table>
              </div>
              <div v-if="importedImplicit">
                <b-table
                  id="uploadImplicitNotImported"
                  striped
                  border
                  hover
                  responsive
                  sticky-header="500px"
                  small
                  :items="uploadImportImplicitlistResultView ? uploadImportImplicitlistResultView.notImportedList : []"
                  :fields="uploadImplicitPreviewFields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  primary-key="_id"
                  no-local-sorting
                  no-provider-paging
                  sort-icon-left
                  class="mt-3"
                >
                <!-- Custom row above header -->
                  <template v-slot:thead-top="data" lang="html">
                    <b-tr>
                      <b-th variant="secondary" :colspan="uploadCommPreviewFields.length">Not Imported</b-th>
                    </b-tr>
                  </template>
                  <!--  rows  -->
                  <template v-slot:cell(isChecked)="data" lang="html">
                    <span><!-- --></span>
                  </template>
                  <template v-slot:cell(status)="data"  lang="html">
                    <span v-if="data.item.statusDescription">{{data.item.statusDescription}}</span>
                  </template>
                  <template v-slot:cell(code)="data" lang="html">
                    <span v-if="data.item.isHeader"><b>{{data.item.code}}</b></span>
                    <span v-if="!data.item.isHeader">{{data.item.code}}</span>  
                  </template>
                  <template v-slot:cell(name)="data" lang="html">
                    <span v-if="data.item.isHeader"><b>{{data.item.name}}</b></span>
                    <span v-if="!data.item.isHeader">{{data.item.name}}</span>  
                  </template>
                </b-table>
              </div>
              <!-- RESULT TABLE -->
            </div>
          <template v-slot:modal-footer="{ cancel, ok }" lang="html">
            <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
              <b-button variant="primary" @click="uploadImplicitFile()">
                Upload
              </b-button>
              <b-button v-if="uploadImportImplicitlistResultView && !importedImplicit" variant="primary" @click="importImplicitList()">
                Import
              </b-button>
            </fragment>
          </template>
        </b-modal>
        <!-- Fine Modal import Implicit-->
      </b-card-text>
    </b-card>
  <b-modal v-if='curItem != null' id="implicitPacksContentModal" title="Implicit Content" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
      <b-container fluid>
        <option v-for="(opt,index) in curItem.implicitList" :key="index" :value="opt">{{opt}}</option>
      </b-container>
  </b-modal>
  
  </section>

</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
const FileDownload = require('js-file-download');
export default {
  name: 'pack_configurator',
  methods: {
    openCloseRow(parentCode) {
      let parentIndex = -1
      let parent = null
      for (let i=0; i<this.packList.length;i++) {
        if (this.packList[i].ocparObj == parentCode) {
          parent = this.packList[i]
          parentIndex = i
          break
        }
      }
      let children = parent.listMasPackCommOpts
      if (this.showChildren.includes(parentCode)) {
        for (let i=0; i<children.length;i++) {
          children[i].isChild = false
          this.packList.splice(parentIndex+1,1)
        }
        this.showChildren.splice(this.showChildren.findIndex(el => el == parentCode),1)
      }
      else {
        for (let i=0; i<children.length;i++) {
          children[i].isChild = true
          this.packList.splice(parentIndex+1+i,0,children[i])
        }
        this.showChildren.push(parentCode)
      }
    },
    ...mapActions([
      'setCurApp',
      'setSpinnerStatus'
    ]),
    getModelBasePackInfo(spinner) {
      if (spinner){
        this.setSpinnerStatus(true);
      }
       this.axios
      .get('/ccb/auth/fe/packConf/basePackInfo/'+this.selectedCountry.id+'/'+this.selectedModel.value+'/'+this.selectedModel.value2 ,  {
        params: null,
        ...this.authHeader}          
          )
          .then((response) => {
            if (spinner){
              this.setSpinnerStatus(false)
            }
            this.defaultElementst.packList  = response.data
            this.packList = response.data
            localStorage.setItem('defaultElementst.packList', JSON.stringify( response.data));
          });
    },
    reloadBaseInfo(){   
      //refresh griglia
      // var defValue = JSON.parse(window.sessionStorage.getItem('defaultElementst.packList'));
      // this.packList = defValue;  
      this.getModelBasePackInfo(true);      
    },
    exportImplicitPack(){
      this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/fe/packConf/exportImplicitPacks' ,  {
        responseType: 'blob',
        params: null,
        ...this.authHeader}          
          )
        .then((response) => {
          this.setSpinnerStatus(false)
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /fileName[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        });
    },
    exportPack(){
      this.setSpinnerStatus(true)
      var params = {
            pCurrentModelVetele: this.selectedModel.value, 
            pModelFilter: this.modelFilter, 
            pCurrentModelYearOnly: this.currentModelYearOnly
            }
      this.axios
      .get('/ccb/auth/fe/packConf/exportCommercialPacks' ,  {
        responseType: 'blob',
        params: params,
        ...this.authHeader}          
          )
        .then((response) => {
          this.setSpinnerStatus(false)
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /fileName[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        });
    },
    initializeUpload(){
      this.uploadImportCommlistResultView = null
      this.$bvModal.show('modal-import')
      this.fileName = ''
      this.imported = false
      this.editUploadList = []
    },
    initializeUploadImplicit(){
      this.uploadImportImplicitlistResultView = null
      this.$bvModal.show('modal-import-implicit')
      this.fileName = ''
      this.importedImplicit = false
      this.editUploadList = []
    },
    importCommList(){
      this.setSpinnerStatus(true)
      let file=document.querySelector('#file-input').files[0]
      let bodyParams = {
        packConfEditedItemList : this.editUploadList
      }
      let formData = new FormData()
      formData.append("uploadFile", file)
      formData.append("importPackConfUtilJson",JSON.stringify(bodyParams))
      this.axios.post("/ccb/auth/fe/packConf/importCommercialPacks", formData , {
          //params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.imported=true
          this.setSpinnerStatus(false)
          this.uploadImportCommlistResultView = result.data
          this.getModelBasePackInfo(true)
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });
    },
    importImplicitList(){
      this.setSpinnerStatus(true)
      let file=document.querySelector('#file-input-implicit').files[0]
      let bodyParams = {
        packConfEditedItemList : this.editUploadList
      }
      let formData = new FormData()
      formData.append("uploadFile", file)
      formData.append("importPackConfUtilJson",JSON.stringify(bodyParams))
      this.axios.post("/ccb/auth/fe/packConf/importImplicitPacks", formData , {
          //params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.importedImplicit=true
          this.setSpinnerStatus(false)
          this.uploadImportImplicitlistResultView = result.data
          this.getModelBasePackInfo(true)
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });
    },
    uploadCommFile(){
      this.setSpinnerStatus(true)
      let file=document.querySelector('#file-input').files[0]
      let formData = new FormData()
      formData.append("uploadFile", file)
      this.axios.post("/ccb/auth/fe/packConf/uploadCommercialPacksFromExcel", formData , {
          //params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.setSpinnerStatus(false)
          this.imported = false
          this.editUploadList = []
          this.uploadImportCommlistResultView = result.data
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });

    },
    uploadImplicitFile(){
      this.setSpinnerStatus(true)
      let file=document.querySelector('#file-input-implicit').files[0]
      let formData = new FormData()
      formData.append("uploadFile", file)
      this.axios.post("/ccb/auth/fe/packConf/uploadImplicitPacksFromExcel", formData , {
          //params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          ...this.authHeader}
        )
        .then((result) => {
          this.setSpinnerStatus(false)
          this.importedImplicit = false
          this.editUploadList = []
          this.uploadImportImplicitlistResultView = result.data
      }).catch((err) => {
        this.setSpinnerStatus(false)
      });

    },
    changeFileName(){
      if(document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
      } else
      {
        this.fileName = '';
      }

    },
    changeFileNameImplicit(){
      if(document.querySelector('#file-input-implicit').files[0] && document.querySelector('#file-input-implicit').files[0].name) {
        this.fileName = document.querySelector('#file-input-implicit').files[0].name;
      } else
      {
        this.fileName = '';
      }

    },
    existsInListByParentCodeAndVet(list,item){
      let result = false
      return list.some(function(field) {
        if (item.parentCode === field.parentCode && item.vetList === field.vetList){
          return true
        } else {
          return false
        }
      });
    },
    editUploadedItem(item){
      if (!this.existsInListByParentCodeAndVet(this.editUploadList, item)) {
        this.editUploadList.push(item)
      } else {
        this.editUploadList.splice(this.editUploadList.indexOf(item), 1)
        this.editUploadList.push(item)
      }
      console.log(this.editUploadList)
    },
  },
  data () {
    return {
      showChildren: [],
      currentPage:1,
      perPage:10,
      sortBy:'code',
      sortDesc: false,
      curItem:null,
      modelFilter:'ALL',
      currentModelYearOnly: false,
      uploadImplicitPreviewFields: [
        {
          key: 'isChecked',
          label: '',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'status',
          label: 'Details',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'code',
          label: 'Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'name',
          label: 'Name',
          thClass: 'newLine',
          visible: true,
          sortable: false
        }
      ], 
      uploadCommPreviewFields: [
        {
          key: 'isChecked',
          label: '',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'status',
          label: 'Details',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'model',
          label: 'Model',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'ver',
          label: 'Market',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'country',
          label: 'Country',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'parentCode',
          label: 'Parent Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'childCode',
          label: 'Child Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
         {
          key: 'inclExcl',
          label: 'Incl / Excl',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'optManovra',
          label: 'Opt manovra',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'alternateSet',
          label: 'Set',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'defaultSet',
          label: 'Default',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'compulsory',
          label: 'Compulsory',
          thClass: 'newLine',
          visible: true,
          sortable: false
        }
      ],
      fields: [
         {
          key: 'plus',
          label: '',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'parentCode',
          label: 'Parent Code',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'childCode',
          //label: 'Hidden by Prod. Cat.',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'inclExcl',
          label: 'Incl / Excl',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'optManovra',
          //label: 'Opt manovra',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'set',
          //label: 'Set',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'default',
          //label: 'Official pack of market',
          thClass: 'newLine',
          visible: true,
          sortable: false
        },
        {
          key: 'implicitPacksContent',
          label: 'Implicit packs content',
          thClass: 'newLine',
          visible: true,
          sortable: false
        }
      ],
      //new
      selectedCountry: (this.getCurUser) ? this.getCurUser.countries[0] : null,
      selectedModel: this.$store.state.selectedModel,
      packList:null,
      defaultElementst:{
        packList: null
      },
      uploadImportCommlistResultView:null,
      uploadImportImplicitlistResultView:null,
      editUploadList:[],
      imported:false,
      importedImplicit:false,
      fileName:'',
      files: [],
      fileLabel:"Choose File",
    }
  },
  computed: {
    visibleFields() {
      //agire sul campo visible dell'array fields per nascondere/mostrare i campi in base alle varie possibilità
      return this.fields.filter(field => field.visible)
    },
    ...mapGetters([
      'getCurLanguage',
      'getCurUser',
      'authHeader',
    ]) 
  },
  watch: {
     selectedCountry(newVal,oldVal){     
      if(newVal.modelGroupItemList && newVal.modelGroupItemList.length > 0 && newVal.modelGroupItemList[0].items.length > 0)
        this.selectedModel = newVal.modelGroupItemList[0].items[0];
      else 
        this.selectedModel = null;
    },
    selectedModel(newVal,oldVal){
      this.getModelBasePackInfo(true);
    },
  },
  mounted() {
    this.selectedCountry = (this.selectedCountry) ? this.selectedCountry : ((this.getCurUser && this.getCurUser.countries && this.getCurUser.countries.length) ? this.getCurUser.countries[0] : null) ;
    this.setCurApp('pack_conf');
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/_variables.scss';
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: .25rem;
}
</style>
